import React from "react";
import { Box } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { useFieldArray, useFormContext } from "react-hook-form";

import { ResultColumns } from "./columnNames/NozzleColumns";
import {
  compactTableProps,
  greyTable,
} from "../../../../../../styles/muiProps";

import {
  useResponsivePvTable,
  getResponsivePvTableProps,
} from "./responsivePvTable";

/**
 * Relative width distribution.
 * These are weights, NOT fixed pixels.
 */
const RESULT_COLUMN_WEIGHTS = {
  "Nozzle Thk Reqd": 1.05,

  "Area Reqd": 1,
  "Area Available": 1.05,

  "Nozzle Weld (A) Reqd": 1,
  "Nozzle Weld (B) Reqd": 1,
  "Nozzle Weld (C) Reqd": 1,

  "Flange MAWP": 1.05,

  "Nozzle MDMT": 1,
  "Flange MDMT": 1,
  "Pad MDMT": 1,
};

const ResultTable = (props) => {
  const { isLoading, isError } = props;

  const { control } = useFormContext();

  const { fields: resultFields } = useFieldArray({
    control,
    name: "DataGridView3",
  });

  const {
    viewportRef,
    tableWidth,
    headerFontSize,
    bodyFontSize,
    columns: responsiveColumns,
  } = useResponsivePvTable(ResultColumns ?? [], RESULT_COLUMN_WEIGHTS);

  const responsiveTableProps = getResponsivePvTableProps({
    tableWidth,
    headerFontSize,
    bodyFontSize,
  });

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",

        boxSizing: "border-box",

        overflowX: "hidden",
        overflowY: "visible",
      }}
    >
      <MaterialReactTable
        /*
         * Base project styling first.
         */
        {...compactTableProps}
        {...greyTable}
        /*
         * Responsive styling must override the base styling.
         */
        {...responsiveTableProps}
        /*
         * IMPORTANT:
         * Keep columns/data AFTER spreads so nothing can
         * accidentally overwrite them with undefined.
         */
        columns={responsiveColumns ?? []}
        data={resultFields ?? []}
        enableSorting={false}
        enableColumnActions={false}
        enableEditing={false}
        enableTopToolbar={false}
        muiToolbarAlertBannerProps={
          isError
            ? {
                color: "error",
                children: "Calculation failed. Please check Input Data",
              }
            : undefined
        }
        state={{
          isLoading,
          showAlertBanner: isError,
        }}
      />
    </Box>
  );
};

export default ResultTable;
